<footer class="site-footer bg-primary text-primary-foreground py-4">
  <div class="container py-3">
    <div class="row g-4">
      <div class="col-sm-7">
        <img src="/assets/img/logo-white.png" />
        <p class="opacity-75 line-height-140p fs-14 mt-3" style="max-width: 360px;">Nigeria's primary statutory agency for the regulation and supervision of corporate structures under the Companies and Allied Matters Act.</p>
      </div>
      <div class="col-sm-5">
        <h3 class="heading-font fs-15 fw-bold mb-2">Quick Link</h3>
        <ul class="list-unstyled fs-14 d-flex flex-column gap-1">
          <li><a class="text-primary-foreground" [routerLink]="'/search'">Search for Business Entity</a></li>
          <li><a class="text-primary-foreground" [routerLink]="'/about'">About CAC BOR</a></li>
          <li><a class="text-primary-foreground" [routerLink]="'/faq'">Frequently Asked Questions</a></li>
          <li><a class="text-primary-foreground" [routerLink]="'/contact'">Contact Us</a></li>
          <li><a class="text-primary-foreground" [routerLink]="'/legals/privacy'">Privacy Policy</a></li>
        </ul>
      </div>
    </div>
  </div>
  <div class="border-top my-3 opacity-25"></div>
  <div class="container py-3">
    <div class="d-flex align-items-center gap-3 justify-content-between flex-wrap text-center">
      <p class="opacity-75 line-height-140p fs-14" >© Corporate Affairs Commission of Nigeria. All Rights Reserved.</p>
      <div class="d-flex align-items-center gap-1 justify-content-end">
        <span class="opacity-75 line-height-140p fs-14" >Powered by:</span>
        <a href="https://oasismgt.net" target="_blank"><img src="/assets/img/oasis-logo.svg" /></a>
      </div>
    </div>
  </div>
</footer>
